const name = 'circle-u';


const contents = `
<circle cx="31" cy="41" r="29"/>
<path d="M31 55.293c-3.48 0-6.228-.856-8.244-2.569-2.016-1.712-3.025-4.391-3.025-8.037v-17.98h5.635v17.98c0 .663.055 1.34.165 2.03.11.69.36 1.326.746 1.906.387.58.967 1.063 1.74 1.45s1.795.58 3.066.58c1.215 0 2.196-.193 2.941-.58.746-.387 1.312-.87 1.699-1.45s.635-1.215.746-1.906c.11-.69.165-1.367.165-2.03v-17.98h5.635v17.98c0 3.646-1.009 6.325-3.025 8.037-2.016 1.713-4.764 2.569-8.244 2.569z" fill="#FFF"/>
`;


/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'U',
};

export default icon;
